import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ImportFCLData, ImportFCLResponse } from '@/types/tableImportFCL';

export const getImportFCLTable = async (
  oid: number
): Promise<ImportFCLData[]> => {
  try {
    const res = await apiClient.post<ImportFCLResponse>(
      Endpoints.ImportTableFCL,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
